{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/html",
	"title": "Custom HTML",
	"category": "widgets",
	"description": "Add custom HTML code and preview it as you edit.",
	"keywords": [ "embed" ],
	"textdomain": "default",
	"attributes": {
		"content": {
			"type": "string",
			"source": "raw",
			"role": "content"
		}
	},
	"supports": {
		"customClassName": false,
		"className": false,
		"html": false,
		"interactivity": {
			"clientNavigation": true
		},
		"customCSS": false
	},
	"editorStyle": "wp-block-html-editor"
}
